import { ThemeOptions } from '@material-ui/core';

type Typography = Pick<ThemeOptions, 'typography'>;

export const customTypography: Typography = {
  typography: {
    fontFamily: "'IBM Plex Sans', sans-serif",
    // $headline-1
    h1: {
      fontWeight: 300,
      fontSize: '3.375rem',
      lineHeight: '4rem',
      letterSpacing: 0,
    },
    // $headline-2
    h2: {
      fontWeight: 300,
      fontSize: '2.625rem',
      lineHeight: '3.125rem',
      letterSpacing: 0,
    },
    // $headline-3
    h3: {
      fontWeight: 400,
      fontSize: '2rem',
      lineHeight: '2.5rem',
      letterSpacing: '0.016rem',
    },
    // $headline-4
    h4: {
      fontWeight: 400,
      fontSize: '1.75rem',
      lineHeight: '2.25rem',
      letterSpacing: 0,
    },
    // $headline-5
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
      letterSpacing: '0.009rem',
    },
    // $headline-6
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '1.375rem',
      letterSpacing: '0.016rem',
    },
    // $subtitle-1
    subtitle1: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '1.25rem',
      letterSpacing: '0.011rem',
    },
    // $subtitle-2
    subtitle2: {
      fontWeight: 400,
      fontSize: '0.857rem',
      lineHeight: '1.25rem',
      letterSpacing: '0.01rem',
    },
    // $body-1
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      letterSpacing: '0.031rem',
    },
    // $body-2
    body2: {
      fontWeight: 400,
      fontSize: '0.857rem',
      lineHeight: '1.25rem',
      letterSpacing: '0.016rem',
    },
    // $caption-1
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: '1rem',
      letterSpacing: '0.025rem',
    },
  },
};
